var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 12.5L22.6924 30.5H1.90774L12.3 12.5Z",
    fill: "#DD9302"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 12.5076L33.0847 12.5076L22.6924 30.5076L12.3 12.5076Z",
    fill: "#C03939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 12.5076L22.6924 -5.4924L33.0847 12.5076L12.3 12.5076Z",
    fill: "#922CD0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 12.5L1.90775 -5.5L22.6924 -5.5L12.3 12.5Z",
    fill: "#354ED1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.44995 12.5076L1.94235 -5.4924L12.3347 12.5076L-8.44995 12.5076Z",
    fill: "#2CD08C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.5 12.5076L12.2846 12.5076L1.8923 30.5076L-8.5 12.5076Z",
    fill: "#C0B239"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColors);
export default __webpack_public_path__ + "static/media/colors.99d7c04f7d30570a0eeba4a1827345a3.svg";
export { ForwardRef as ReactComponent };